import { SchemaSection } from '../../../schemas/models/schemaSection';
import {
  formulasInfoPayloadSchema,
  formulasInfoResponseSchema,
} from './formulasInfo.schema';

export type FormulasInfoPayload = {
  schemaContent: SchemaSection[];
};

export type FormulasInfoResponse = {
  results: Array<{
    formula?: string;
    type?: 'formula' | 'reasoning' | 'lookup';
    dependencies: Array<string>;
    id: string;
    context?: string[];
  }>;
};

export const formulasInfo = (payload: FormulasInfoPayload) => {
  return {
    endpoint: `internal/schemas/formulas_info`,
    method: 'POST',
    responseSchema: formulasInfoResponseSchema,
    payloadSchema: formulasInfoPayloadSchema,
    payload,
  } as const;
};
